import React, { forwardRef, useCallback, useContext } from "react";
import ReactInputMask from "react-input-mask";
import { FormControlContext } from "../../FormControl/FormControlContext";
import { TextInput, TextInputProps } from "../TextInput";

export type MaskedInputProps = TextInputProps & {
  mask: string;
};

export const MaskedInput = forwardRef<React.ElementRef<typeof ReactInputMask>, MaskedInputProps>(
  (
    {
      mask,
      onFocus,
      name: nameProps,
      disabled: disabledProps,
      onBlur: onBlurProps,
      onChange: onChangeProps,
      value: valueProps,
      ...props
    },
    forwardedRef
  ) => {
    const formControl = useContext(FormControlContext);

    const name = nameProps ?? formControl.name;
    const disabled = disabledProps ?? formControl.disabled;
    const onBlur = onBlurProps ?? formControl.onBlur;
    const onChange = onChangeProps ?? formControl.onChange;
    const value = valueProps ?? formControl.value;
    const isDirty = !!formControl.error;

    const CustomInput = useCallback(
      (inputProps: TextInputProps) => <TextInput disabled={disabled} {...props} {...inputProps} />,
      [props]
    );

    return (
      <ReactInputMask
        alwaysShowMask
        mask={mask}
        maskChar=""
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        value={value}
        disabled={disabled}
        name={name}
        data-dirty={isDirty}
        ref={forwardedRef}
      >
        {CustomInput}
      </ReactInputMask>
    );
  }
);

MaskedInput.displayName = "MaskedInput";
